var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSetting4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3999 10.1069H20.9599C20.4399 10.1069 20.0266 9.69357 20.0266 9.17357C20.0266 8.65357 20.4399 8.24023 20.9599 8.24023H28.3999C28.9199 8.24023 29.3333 8.65357 29.3333 9.17357C29.3333 9.69357 28.9199 10.1069 28.3999 10.1069Z",
    fill: "#87888B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.55996 10.1069H3.59996C3.07996 10.1069 2.66663 9.69357 2.66663 9.17357C2.66663 8.65357 3.07996 8.24023 3.59996 8.24023H8.55996C9.07996 8.24023 9.49329 8.65357 9.49329 9.17357C9.49329 9.69357 9.06663 10.1069 8.55996 10.1069Z",
    fill: "#87888B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.52 14.4401C16.4287 14.4401 18.7866 12.0821 18.7866 9.17341C18.7866 6.26471 16.4287 3.90674 13.52 3.90674C10.6113 3.90674 8.2533 6.26471 8.2533 9.17341C8.2533 12.0821 10.6113 14.4401 13.52 14.4401Z",
    fill: "#87888B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4 23.7465H23.44C22.92 23.7465 22.5067 23.3332 22.5067 22.8132C22.5067 22.2932 22.92 21.8799 23.44 21.8799H28.4C28.92 21.8799 29.3334 22.2932 29.3334 22.8132C29.3334 23.3332 28.92 23.7465 28.4 23.7465Z",
    fill: "#87888B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.04 23.7465H3.59996C3.07996 23.7465 2.66663 23.3332 2.66663 22.8132C2.66663 22.2932 3.07996 21.8799 3.59996 21.8799H11.04C11.56 21.8799 11.9733 22.2932 11.9733 22.8132C11.9733 23.3332 11.5466 23.7465 11.04 23.7465Z",
    fill: "#87888B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.48 28.0934C21.3887 28.0934 23.7467 25.7354 23.7467 22.8267C23.7467 19.918 21.3887 17.5601 18.48 17.5601C15.5713 17.5601 13.2134 19.918 13.2134 22.8267C13.2134 25.7354 15.5713 28.0934 18.48 28.0934Z",
    fill: "#87888B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting4);
export default __webpack_public_path__ + "static/media/setting-4.e01dd3f0ba24b89185de1cab7f288241.svg";
export { ForwardRef as ReactComponent };